const permissions = {
    search_placeholder: 'Tìm theo tên API hoặc tên quyền',
    search_placeholder_without_api: 'Tìm theo tên quyền',
    name_column: 'Quyền',
    description_column: 'Mô tả',
    api_column: 'API',
    placeholder_title: 'Quyền',
    placeholder_description: 'Quyền là quyền được phép truy cập tài nguyên (chúng tôi gọi đó là tài nguyên API).',
    edit: 'Chỉnh sửa quyền',
    delete: 'Xóa quyền',
    remove: 'Xóa quyền',
    edit_title: 'Chỉnh sửa quyền API',
};
export default Object.freeze(permissions);
